// ─────────────────────────────────────────────────────────────────────────
//  ClickViewer · web · 연락처
//
//  ★ 별도 컴포넌트인 이유: 이 줄이 **여러 화면에 반드시 있어야** 하기 때문이다.
//    로그인 · 빈 목록 · 404 · 연결 실패 · 초대 막다른 화면. 전부 「사용자가 스스로
//    풀 수 없는 자리」다.
//
//    로그인 수단이 이메일 코드 **하나뿐**이라, 아래 중 하나만 걸려도 그 사람은 완전히 막힌다.
//      · 코드 메일이 스팸함으로 갔다
//      · 회사 메일 게이트웨이가 격리했다 (국내 기업 메일에서 실제로 흔하다)
//      · 이메일 주소를 잘못 쳤다 — 그런데 **틀렸다는 답이 안 온다**(가입 여부를 숨기므로)
//      · 로그인은 됐는데 초대를 못 받아 아무것도 안 보인다
//
//    이때 연락할 곳이 화면에 없으면 그 사람은 **연락 자체를 못 한다.** 그리고 우리는
//    막힌 사람이 있다는 사실조차 모른다 — 서버 로그에는 성공한 204 만 남는다.
//
//  ⚠️⚠️ 옛 구현은 **전부 muted** 였다(`<Text size="sm" c="dimmed">`).
//     야외 2.72:1 · 직사광 1.43:1 — **막힌 사람의 유일한 탈출구가 화면에서 가장 안 보이는
//     글자**였다. muted 는 라벨 전용이다. 여기는 라벨이 아니라 A 등급 정보다.
//
//  ⚠️ 주소를 **문장 안에** 넣지 않는다. 두 가지가 동시에 해결되지 않기 때문이다:
//     문장 안의 링크에 44px 최소 높이를 주면 줄 간격이 벌어지고, 안 주면 장갑으로 못 누른다.
//     → **줄을 나눈다.** 주소가 자기 줄을 가지면 44px 을 줘도 아무것도 안 망가지고,
//       고정폭 16px 이라 오타를 눈으로 대조할 수도 있다.
// ─────────────────────────────────────────────────────────────────────────

import { Anchor, Stack, Text } from '@mantine/core';
import { CONTACT_EMAIL } from '../config';

export function Contact({
  prefix = '막히면 연락 주세요',
  /** 메일 제목. 화면마다 다르게 주면 우리가 어디서 막혔는지 알 수 있다. */
  subject = '[ClickView] 로그인/접속 문의',
}: {
  prefix?: string;
  subject?: string;
}) {
  return (
    <Stack gap={4}>
      <Text size="sm" c="var(--cv-ink-2)">
        {prefix}
      </Text>
      <Anchor
        href={`mailto:${CONTACT_EMAIL}?subject=${encodeURIComponent(subject)}`}
        // .cv-tap-link : 손가락으로 누르는 링크임을 **명시**한다(global.css §②).
        //                자기 줄을 쓰므로 44px 을 줘도 본문 줄 간격이 안 벌어진다.
        className="cv-mono cv-tap-link"
        size="md"
        fw={600}
      >
        {CONTACT_EMAIL}
      </Anchor>
    </Stack>
  );
}
